import { formatDollarAmount } from '../../../../utils/formatting';

const getDisplayValue = (value: number | string): string => {
  if (typeof value !== 'number') return value;
  if (Number.isNaN(value)) return '$0';

  return formatDollarAmount(value, false);
};

type GraphTooltipProps = {
  readonly title: string;
  readonly rows: { label: string; value: number | string }[];
  readonly totalLabel: string;
  readonly totalValue: number;
};

export function GraphTooltip({ title, rows, totalLabel, totalValue }: GraphTooltipProps) {
  return (
    <div className="min-w-[200px] rounded-lg border border-slate-200 bg-white p-3 shadow-lg">
      <h4 className="mb-2 text-sm font-bold text-slate-900">{title}</h4>

      <div className="space-y-1">
        {rows.map((row) => (
          <div key={row.label} className="flex items-center justify-between gap-4">
            <span className="text-xs font-medium text-slate-500">{row.label}:</span>
            <span className="text-xs font-semibold text-slate-900">{getDisplayValue(row.value)}</span>
          </div>
        ))}
      </div>

      <div className="my-2 h-px w-full bg-slate-100" />

      <div className="flex items-center justify-between gap-4">
        <span className="text-xs font-medium text-slate-500">{totalLabel}:</span>
        <span className="text-sm font-bold text-slate-900">{getDisplayValue(totalValue)}</span>
      </div>
    </div>
  );
}
